import { combineReducers } from 'redux-immutable';
import { pageInstructionsReducer, moreInstructionsReducer } from './help';

export default combineReducers({
  pageInstructions: pageInstructionsReducer,
  moreInstructions: moreInstructionsReducer,
});
